// What the reschedule page says for each `errorCode` the API answers with
// (GET /widget/pages/bookings/reschedule/:id and …/listings/:listingId/sessions
// answer 200 with { error, errorCode } when the booking can't be moved).
// A port of v1's ErrorCodeView, plus a fallback for a code v1 didn't know
// (v1 rendered an empty page for one).

export const RESCHEDULE_ERROR_CODES = [
  "USER_NOT_LOGGED_IN",
  "CANCELLATION_POLICY_ISSUE",
  "BOOKING_RESCHEDULE_NOTENOUGH_TIME",
  "BOOKING_RESCHEDULE_TERM_ALREADY_STARTED",
  "BOOKING_ALREADY_REFUNDED",
] as const;

export type RescheduleErrorCode = (typeof RESCHEDULE_ERROR_CODES)[number];

export type RescheduleErrorCopy = {
  title: string;
  message: string;
  /** What the page offers next: sign in, read the terms, or nothing. */
  action: "sign-in" | "terms" | null;
};

export function rescheduleErrorCopy(code: string, apiMessage?: string): RescheduleErrorCopy {
  switch (code) {
    case "USER_NOT_LOGGED_IN":
      return {
        title: "You need to sign in to reschedule",
        message:
          "To reschedule this booking, sign in or create an account with the same email address you used to book.",
        action: "sign-in",
      };
    case "CANCELLATION_POLICY_ISSUE":
      return {
        title: "Unable to reschedule this booking",
        message: "This booking can’t be rescheduled under our cancellation policy.",
        action: "terms",
      };
    case "BOOKING_RESCHEDULE_NOTENOUGH_TIME":
    case "BOOKING_RESCHEDULE_TERM_ALREADY_STARTED":
      return {
        title: "Unable to reschedule this booking",
        message:
          "This booking can’t be rescheduled automatically. Please get in touch by replying to your booking email and we’ll help you further.",
        action: null,
      };
    case "BOOKING_ALREADY_REFUNDED":
      return {
        title: "Unable to reschedule this booking",
        message: "This booking can’t be rescheduled as it has already been refunded. Please book and pay again to attend.",
        action: null,
      };
    default:
      return {
        title: "Unable to reschedule this booking",
        message: apiMessage?.trim() || "Please get in touch by replying to your booking email and we’ll help you further.",
        action: null,
      };
  }
}
